import type { V2Bag, V2Value } from "@/features/applications/api/applications.api";
import { lookupZip } from "@/hooks/useZipAutoFill";

const ZIP_TARGETS: Record<string, { state: string; city: string }> = {
  legalZip: { state: "legalState", city: "legalCity" },
  dbaZip: { state: "dbaState", city: "dbaCity" },
  homeZip: { state: "homeState", city: "homeCity" },
};

export function zipAutoFill(key: string, value: V2Value, apply: (patch: V2Bag) => void) {
  const target = ZIP_TARGETS[key];
  if (!target || typeof value !== "string") return;
  lookupZip(value).then((place) => {
    if (!place) return;
    const patch: V2Bag = {};
    if (place.state) patch[target.state] = place.state;
    if (place.city) patch[target.city] = place.city;
    if (Object.keys(patch).length > 0) apply(patch);
  });
}
